var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tr',[_c('b-th',{attrs:{"colspan":_vm.isAssetView ? '5' : '10',"variant":"dark"}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }